import { useCallback } from 'react';
import { rotateNext } from '../utils';

const LEFT_ROTATION = {
  'rotate-0': 'rotate-270',
  'rotate-90': 'rotate-0',
  'rotate-180': 'rotate-90',
  'rotate-270': 'rotate-180',
};

export const useRotateLeft = (upload) =>
  useCallback(
    (e) => {
      e.stopPropagation();
      rotateNext(upload, LEFT_ROTATION);
    },
    [upload],
  );
